// Platform-aware URL handling. On the web/Capacitor (Android), absolute external
// URLs open in the system browser. Inside Telegram, the WebApp SDK's openLink()
// opens in the user's external browser instead of the in-app browser.

import { telegram } from './telegram';

export function openExternal(url: string): void {
  if (!url) return;
  const tg = window.Telegram?.WebApp;
  if (tg && typeof tg.openLink === 'function') {
    tg.openLink(url);
    return;
  }
  // Web + Capacitor: window.open with _blank lands in the system browser on
  // Android (Capacitor maps absolute http(s) URLs to an external intent by default).
  window.open(url, '_blank', 'noopener,noreferrer');
}

// True when the app is running inside the Telegram mini-app environment.
export const isMiniApp = (): boolean => telegram.isAvailable();
